import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icons from "../../../Assets/Icons";
import "./PatientHistoryDetails.css";

const PatientHistoryItem = ({ historyItem, isExpanded, onToggle }) => {
    const { t } = useTranslation();

    return (
        <div className="phi-item">
            <div className="phi-header" onClick={onToggle}>
                <div className="phi-left">
                    <div className="phi-date-icon">
                        <img src={Icons.CalenderIcon} alt="calendar" />
                    </div>
                    <div className="phi-info">
                        <p className="phi-date">{historyItem.date}</p>
                        <p className="phi-service">{historyItem.serviceType}</p>
                    </div>
                </div>
                <div className="phi-toggle">
                    <img
                        src={Icons.downArrow}
                        alt="toggle"
                        className={`phi-arrow-icon ${isExpanded ? "open" : ""}`}
                    />
                </div>
            </div>

            {isExpanded && (
                <div className="phi-content">
                    <div className="phi-nurse-observations">
                        <p className="phi-section-title">{t("nurseObservations")}</p>
                        <div className="phi-images-gallery">
                            {historyItem.woundCare.images.map((image, index) => (
                                <div key={index} className="phi-image-wrapper">
                                    <img
                                        src={image}
                                        alt={`wound care ${index + 1}`}
                                        className="phi-image"
                                    />
                                    <div className="phi-image-overlay">
                                        <img src={Icons.eye} alt="view" className="phi-eye-icon" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="phi-observations-text">
                            <p className="phi-label">{t("nurseObservations")}</p>
                            <p className="phi-text">{historyItem.woundCare.observations}</p>
                        </div>
                    </div>

                    <div className="phi-nurse-notes">
                        <p className="phi-label">{t("nurseNotes")}</p>
                        <p className="phi-text">{historyItem.woundCare.notes}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PatientHistoryItem;
